module.exports = __webpack_public_path__ + "media/images/enable_camera-e06621d2dae531d54798ae5aef4ea435.svg";